export default __webpack_public_path__ + "static/media/zoom.f7b5b7bf.svg";